export default {
  // eslint-disable-next-line
  [process.env.LANGUAGE]: require(`./${process.env.LANGUAGE}.json`)
};
